module.exports = __webpack_public_path__ + "img/1484011171.e855fe77.jpg";